import _extends from 'babel-runtime/helpers/extends';

import DownloadButton from '@/components/DownloadButton/index.vue';
import DownloadResourceButtonPopover from './download-resource-button-popover.vue';
import resourceMixin from '@/views/creative/mixin/resource';
import categoryMixin from '@/views/creative/mixin/category.js';
import { getModelTex, isPureModel } from '@/store/creative/template/model/util';
import { getFileExtension } from '@com/utils/file';
import { mapState } from 'vuex';
// import useIdToFindResourceList from '@/views/creative/utils/use-id-to-find-resource-list.js'
import { get3dModelTextureCategoryList } from '@/views/creative/utils';

export default {
  mixins: [resourceMixin, categoryMixin],
  components: { DownloadButton: DownloadButton, DownloadResourceButtonPopover: DownloadResourceButtonPopover },
  props: {
    category: {
      type: Object,
      required: true
    },
    resource: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    buttonAttrs: {
      type: Object
    }
  },
  computed: _extends({}, mapState({
    templateConfig: function templateConfig(state) {
      return state.creative.template.templateConfig || {};
    },
    hasMvPlayable: function hasMvPlayable(state) {
      return state.creative.template.hasMvPlayable;
    }
  }), {
    downloadUrl: function downloadUrl() {
      // 如果是模型资源，下载的时候，需要把模型的资源文件也下载下来
      if (this.isModel) {
        if (this.hasMvPlayable) {
          // 模型和模型贴图分开下载；存在多个文件时，会直接下载extend_files_url内容
          if (this.resource.extra && this.resource.extra.extend_files_url && this.resource.extra.extend_files_url.length) {
            return this.resource.extra.extend_files_url.join(',');
          }
          if (this.resource.extra && this.resource.extra.origin_file_url) {
            return this.resource.extra.origin_file_url;
          }
        } else {
          // 历史cocos模型保持原逻辑
          if (this.resource.extra && this.resource.extra.origin_file_url) {
            var fbxFileUrl = this.resource.extra.origin_file_url;
            // 如果是纯模型，直接下载 fbx 的 zip 包即可
            if (isPureModel(this.resource.preview_urls)) {
              return fbxFileUrl;
            }
            var texUrl = getModelTex(this.resource.preview_urls);
            // 如果是模型资源，下载的时候，需要把模型的资源文件也下载下来
            return fbxFileUrl + ',' + texUrl;
          }
          console.warn('缺少 fbx 的源文件');
        }
      }
      if (this.isZip && getFileExtension(this.resource.file_url) !== 'zip') {
        return this.resource.file_url + '.zip';
      }
      return this.resource.file_url;
    },
    textureDownloadUrl: function textureDownloadUrl() {
      var textureCategoryList = get3dModelTextureCategoryList(this.templateConfig.resource, this.category.prefix);
      var textureResourceUrl = textureCategoryList.map(function (item) {
        return item.file_url;
      });
      return textureResourceUrl.join(',');
    },
    downloadName: function downloadName() {
      if (this.isModel) {
        return this.resource.prefix + '.zip';
      }
      return this.resource.file_name || '';
    },
    textureDownloadName: function textureDownloadName() {
      if (this.isModel && this.textureDownloadUrl.indexOf(',') > -1) {
        return this.resource.prefix + '.zip';
      }
      return this.resource.prefix + '.' + getFileExtension(this.textureDownloadUrl);
    }
  })
};